/**
 * single media (not playlist) embed code
 * currently only iframe
 */
export default class EmbedV7 {

    static template = "<iframe id=\"kaltura_player\" type=\"text/javascript\"  src='{IFRAME_URL}' {STYLING} allowfullscreen webkitallowfullscreen mozAllowFullScreen allow=\"autoplay *; fullscreen *; encrypted-media *\" {SANDBOX} title=\"{TITLE}\"></iframe>";

    static formatStyle = (style: string | number) => {
        if (typeof style !== 'string') {
            // we got a number, assume it's px:
            return style + 'px';
        } else if (style.includes('px') || style.includes('%')) {
            // if we have either px or % value, return it:
            return style;
        } else {
            // handle all other options in order to prevent ts error
            return parseInt(style) + 'px';
        }
    }

    /**
     * generate dynamic embed
     */
    static EmbedCodeV7(params: Record<string, any>) {

        let out = EmbedV7.template;
        const widget = params['WIDGET_ID'] ? `&config[provider]=${JSON.stringify({widgetId: params['WIDGET_ID']})}` : "";

        const omitSandbox = params['OMIT_SANDBOX'];
        const iframeSandboxAttr = omitSandbox
            ? ""
            : 'sandbox="allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"';
        out = out.replace("{SANDBOX}", iframeSandboxAttr);

        let style = ' style="border: 0;"' ;
        if (params['HEIGHT'] && params['WIDTH']) {
            // if value is string use as is, otherwise assume its px
            const width = EmbedV7.formatStyle(params['WIDTH']);
            const height = EmbedV7.formatStyle(params['HEIGHT']);
            style = ' style="width: ' + width + ';height: ' + height + ';border: 0;"';
        }
        out = out.replace('{STYLING}', style);

        let timing = '';
        if (params['START_TIME']) {
            timing = `&config[playback]=${JSON.stringify({startTime: params['START_TIME']})}`
        }
        const iframeUrl = '{HOST}/p/{PARTNER_ID}/embedPlaykitJs/uiconf_id/{UICONF_ID}?iframeembed=true&entry_id={ENTRY_ID}' + widget + timing;
        out = out.replace('{IFRAME_URL}', iframeUrl);

        for (const name in params) {
            const rg = new RegExp("{" + name + "}", "g");
            out = out.replace(rg, params[name]);
        }

        return out;
    }
}
